import(/* webpackMode: "eager" */ "/home/sherman/orion-jewellery/node_modules/next/dist/client/link.js");
